import { Autocomplete, Button, Field, SearchField } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './customer-account-filter.module.scss';
import { prettifyCustomerStatus } from 'utils';
import locale from 'localization';
import CustomerStatus from 'enums/driver-status';
import SelectProduct from 'components/field/select-product/select-product';

const CustomerAccountFilter = ({
  filterState,
  onStatusChange,
  onSearchChange,
  onProductChange,
  onSearch,
  fetchingReport,
  onViewDetail
  // onPrintPassbook
}) => {
  const onStatusChangeCb = useCallback(
    (name, { value }) => {
      if (onStatusChange) return onStatusChange(value || 'all');
    },
    [onStatusChange]
  );

  const onProductChangeCb = useCallback(
    (name, { label, value }) => {
      if (onProductChange) return onProductChange({ label, value });
    },
    [onProductChange]
  );

  const onSearchChangeCb = useCallback(
    (name, { value }) => {
      if (onSearchChange) {
        return onSearchChange('searchKey', { value });
      }
    },
    [onSearchChange]
  );

  const onSearchCb = useCallback(
    (searchKey) => {
      if (onSearch) {
        return onSearch(searchKey);
      }
    },
    [onSearch]
  );

  return (
    <div className={styles.filter}>
      <div className={styles.filterContent}>
        <Field className={styles.status} label="Status">
          <Autocomplete
            name="status"
            value={filterState.status}
            options={[
              { label: locale.all, value: 'all' },
              {
                label: prettifyCustomerStatus(CustomerStatus.Active),
                value: CustomerStatus.Active
              },
              {
                label: prettifyCustomerStatus(CustomerStatus.Terminated),
                value: CustomerStatus.Terminated
              },
              {
                label: prettifyCustomerStatus(CustomerStatus.Delinquent),
                value: CustomerStatus.Delinquent
              }
            ]}
            onChange={onStatusChangeCb}
          />
        </Field>
        <Field className={styles.status} label="Product">
          <SelectProduct
            {...filterState?.product}
            onChange={onProductChangeCb}
            placeholder="All"
            hasAll
            value={filterState.product}
          />
        </Field>

        <Field className={styles.search} label="Search">
          <SearchField
            placeholder={'MIF Number'}
            value={filterState.searchKey}
            onChange={onSearchChangeCb}
            onEnter={onSearchCb}
            restrict={false}
          />
        </Field>
      </div>
      {/* <Field className={styles.downloadButton}>
        <Button exportButton onClick={onPrintPassbook} loading={fetchingReport}>
          Print Passboook
        </Button>
      </Field> */}
      <Field className={styles.viewMemberDetail}>
        <Button outline onClick={onViewDetail} style={{ width: '190px' }}>
          Member Detail
        </Button>
      </Field>
    </div>
  );
};

export default CustomerAccountFilter;
